// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3k-pv","col":"styles_col__3vSD_"};